<template>
<div class="customer-service-wrapper">

  <el-card class="box-card">

    <div slot="header" class="header clearfix">
      <span>
        <el-avatar :size="50" :src="mate.avatar" />
        <span class="service-name">{{mate.name}}</span>
      </span>
      <el-button style="float: right; padding: 3px 0" type="text" @click="onClose">关闭</el-button>
    </div>

    <div class="chat-table">
      <div :class="{mychat: item.isFromMe, 'nomychat': item.isFromOther}" v-for="(item,index) in chats" :key="index" >
        <el-avatar :size="50" :src="item.fromUserAvatar" />
        <div class="content">{{item.message}}</div>
      </div>
    </div>

    <div class="foot">
      <div class="tool-bar">
        <span class="human-service" @click="onHumanService">人工服务</span>
      </div>
      <div class="message-bar">
        <el-input placeholder="请输入内容" v-model="message">
          <el-button slot="append" @click="onSend">发送</el-button>
        </el-input>
      </div>
    </div>

  </el-card>

</div>
</template>

<script>
import {mapState} from 'vuex'

export default {
  name: 'CustomerService',
  data () {
    return {
      messages: [],
      message: '',
      mate: {
        name: '智能客服',
        avatar: require('@img/robot.png'),
        id:0
      },
    }
  },
  computed: {
    // 将vuex中的全局变量userinfo、colleges映射为组件的局部变量
    ...mapState({
      userinfo: 'userinfo',
    }),
    chats: function() {
      const that = this
      return that.messages.map(
        (e)=>{
          let ret = Object.assign({},e)
          ret.isFromMe = ret.fromUserId==that.userinfo.id
          ret.isFromRobot = e.fromUserId == 0
          ret.isFromOther = !ret.isFromMe
          if(ret.isFromRobot){
            ret.fromUserName='智能客服'
            ret.fromUserAvatar= require('@img/robot.png')
          }
          return ret
        }
      )
    }
  },
  mounted() {
    this.initWebSocket()
  },
  methods:{
    onClose(){
      window.opener=null;
      window.open('',self);
      window.close();
    },
    onSend(){
      const that = this
      if(that.message.length==0){
        that.$message('请输入内容')
        return
      }
        
      let msgData = {
        'message': that.message,
        'fromUserId': that.userinfo.id,
        'toUserId': that.mate.id,
        'sendTime': that.util.date2Str(new Date()),
        'fromUserName': that.userinfo.name,
        'fromUserAvatar': that.userinfo.avatar,
      }
      let json = JSON.stringify(msgData)
      that.websocketsend(json)
      that.messages.push(msgData)
    },
    onHumanService(){
      const that = this
        
      that.axios.get('/chat/humanserviceuserid')
      .then((ret)=>{
        let {code,data} = ret
        if(code != 0){
          that.$message('客服不在线哦')
          that.mate = {
            name: '智能客服',
            avatar: require('@img/robot.png'),
            id:0
          }
          return
        }

        that.mate = {
          id: data.id,
          name: data.name,
          avatar: data.avatar
        }
        this.$message(`${data.name}为您服务`)
      })

    },
    initWebSocket () { // 初始化websocket
      if(this.userinfo){
        const wsuri = this.webSocketUrl + this.userinfo.id + '/false'
        console.log('++++++++++++++++++++++++++')
        console.log(wsuri)
        this.websock = new WebSocket(wsuri)
        this.websock.onmessage = this.websocketonmessage
        this.websock.onopen = this.websocketonopen
        this.websock.onerror = this.websocketonerror
        this.websock.onclose = this.websocketclose
      }
    },
    websocketonopen () { // 连接建立之后执行send方法发送数据
      console.log('连接websocket成功')
      // const actions = { test: '12345' }
      // this.websocketsend(JSON.stringify(actions))
    },
    websocketonerror () { // 连接建立失败重连
      console.log('连接错误')
      this.initWebSocket()
    },
    websocketonmessage (e) { // 数据接收
      const redata = JSON.parse(e.data)
      console.log('接收到数据')
      console.log(redata)
      this.messages.push(redata)
    },
    websocketsend (message) { // 数据发送
      this.websock.send(message)
    },
    websocketclose (e) { // 关闭
      console.log('断开连接', e)
    }
  }
}
</script>

<style lang="stylus" scoped>
.customer-service-wrapper
  margin: 50px 100px 50px 100px
  .header
    height: 50px
    .service-name
      display: inline-block
      height: 50px
      line-height: 50px
      vertical-align: top
      margin-left: 10px
  .foot
    margin-top: 20px
    border-top: solid 1px #aaaaaa
    padding:10px
    .tool-bar
      display: flex
      justify-content: flex-end
      height:40px
      line-height:40px
      padding:0px 5px 10px 0px
      .human-service
        padding:0px 0px 0px 10px
        &:hover
          color: blue
          cursor: pointer
  .chat-table
    overflow-y:scroll
    height: 400px
    .nomychat
      display: flex
      flex-direction: row
      align-items: center
      .content
        position: relative
        margin: 10px
        padding: 5px 10px 5px 10px
        height: 50px
        line-height: 50px
        background: #60BBFD
        -moz-border-radius: 12px
        -webkit-border-radius: 12px
        border-radius: 12px
        &:before
          position: absolute
          content: ""
          width: 0
          height: 0
          right: 100%
          top: 40%
          border-top: 13px solid transparent
          border-right: 10px solid #60BBFD
          border-bottom: 13px solid transparent
    .mychat
      display: flex
      flex-direction: row-reverse
      align-items: center
      .content
        position: relative
        margin: 10px
        padding: 5px 10px 5px 10px
        height: 50px
        line-height: 50px
        background: #60BBFD
        -moz-border-radius: 12px
        -webkit-border-radius: 12px
        border-radius: 12px
        &:before
          position: absolute
          content: ""
          width: 0
          height: 0
          left: 100%
          top: 40%
          border-top: 13px solid transparent
          border-left: 10px solid #60BBFD
          border-bottom: 13px solid transparent
</style>
